import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import httpInterceptor from '../common/APIConfig';

const initialState = {
    loginUser: [],
    loading: false,
    isLoaded: false,
    error: false,
    errorMessage: null
};

export const getUserData = createAsyncThunk(
    'userdetails',
    async (data, { rejectWithValue }) => {
        try {
            const response = await httpInterceptor.get(`/me`);

            console.log("response ", response);
            if (response.status === 200) {
                return {
                    role: response.data.role,
                    user_name: data.user_name,
                    perms: response.data.perms
                };
            }
        } catch (error) {
            console.log(error);
            if (!error.response) {
                return rejectWithValue(error.message);
            }

            // Check for 404 specifically and return custom message
            if (error.response.status === 404) {
                return rejectWithValue(
                    "User not found. In case of needing to gain access to this application, please raise an access request to cloud-services@mosaic.siemens-energy.cloud"
                );
            }

            return rejectWithValue(error.response.data);
        }
    }
);

export const userSlice = createSlice({
    name: 'loginUser',
    initialState,
    reducers: {
        setUserRole(state, action) {
            state.loginUser = state.loginUser || {};
            state.loginUser.role = action.payload;
        },
        setLoginUser(state, action) {
            state.loginUser = action.payload;
        }
    },
    extraReducers: builder => {
        builder.addCase(getUserData.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getUserData.fulfilled, (state, action) => {
            state.loading = false;
            state.loginUser = action.payload;
            state.isLoaded = true;
            state.error = false;
        });
        builder.addCase(getUserData.rejected, (state, action) => {
            state.loading = false;
            state.errorMessage = action.payload;
            state.isLoaded = true;
            state.error = true;
        });
    }
});

export default userSlice.reducer;
